import React from 'react'

import AbsolutePageTemplate from '../../../components/templates/AbsolutePageTemplate'
import PageContent from './_shared/PageContent'
import PageHeader from './_shared/PageHeader'
import ServiceOrdersLoader from './_load/ServiceOrderLoader'

const TemplateAxonPdfPage = ({ id, templateId }) => {
  return (
    <AbsolutePageTemplate>
      <ServiceOrdersLoader id={id}>
        <PageHeader templateId={parseInt(templateId)} />
        <PageContent templateId={parseInt(templateId)} />
      </ServiceOrdersLoader>
    </AbsolutePageTemplate>
  )
}

export default TemplateAxonPdfPage
